
import { SetupContext } from 'vue'
import { useRouter } from 'vue-router'

export default {
  name: 'IconButton',

  props: {
    label: {
      type: String,
      default: 'ボタン'
    },
    path: {
      type: String,
      default: '/'
    },
    icon: String
  },

  setup(props: any, context: SetupContext) {
    const router = useRouter()

    const clickButton = () => {
      if (props.path !== '/') {
        router.push({ path: props.path })
      } else {
        context.emit('click-btn')
      }
    }

    const getIcon = (icon: string) => {
      return require(`@/assets/images/icon/${icon}.svg`)
    }

    return {
      clickButton,
      getIcon
    }
  }
}
